import React from "react";
import Slider from "react-slick";
import { useTranslation } from "@/i18n";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Icons aligned by index with t.references.cards; slots for real client logos later
const CARD_ICONS = ["account_tree", "neurology", "sensors"];

export const References: React.FC = () => {
  const t = useTranslation();

  const scrollTo = (elementId: string) => {
    document.getElementById(elementId)?.scrollIntoView({ behavior: "smooth" });
  };

  const carouselSettings = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    dots: true,
    dotsClass: "slick-dots references-dots",
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 680, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <div id="referenzen"></div>
      <div className="py-[72px] md:py-[120px]">
        <div className="max-w-screen-xl m-auto px-[38px] 2xl:px-0">
          <p className="text-[#01C6FB] font-semibold tracking-[0.18em] uppercase text-[13px] md:text-[14px]">
            {t.references.overline}
          </p>
          <h2 className="mt-3 text-[#171A1F] font-bold text-[28px] leading-[38px] md:text-[44px] md:leading-[56px]">
            {t.references.headline}
          </h2>
          <p className="mt-5 max-w-3xl text-[16px] leading-[26px] md:text-[18px] md:leading-[30px] text-base-600">
            {t.references.intro}
          </p>
        </div>

        <div className="max-w-screen-xl m-auto mt-[40px] md:mt-[48px] px-[22px] 2xl:px-0">
          <Slider {...carouselSettings}>
            {t.references.cards.map((card, index) => (
              <div key={card.title} className="px-[16px] pb-[16px]">
                <div className="group flex flex-col h-[360px] md:h-[340px] rounded-[20px] border border-base-200 bg-white p-[28px] shadow-sm transition-shadow hover:shadow-lg">
                  {/* Logo slot - replaced by real client logos later */}
                  <span className="material-symbols-outlined flex h-[52px] w-[52px] items-center justify-center rounded-full bg-[#FAFAFB] border border-base-200 text-[26px] text-base-500 transition-colors group-hover:text-[#01C6FB] group-hover:border-[#01C6FB]/40">
                    {CARD_ICONS[index]}
                  </span>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {card.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full border border-[#01C6FB]/50 px-3 py-1 text-[12px] font-semibold text-[#0195bd]"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="mt-3 text-[18px] md:text-[20px] font-bold text-[#171A1F]">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-[15px] leading-[25px] text-base-600">
                    {card.text}
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div className="max-w-screen-xl m-auto px-[38px] 2xl:px-0">
          {/* Fact band */}
          <div className="mt-[40px] md:mt-[48px] rounded-[12px] bg-[#FAFAFB] border border-base-200 px-[24px] py-[18px] flex flex-col md:flex-row items-center justify-center gap-2 md:gap-8 text-center">
            {t.references.facts.map((fact) => (
              <p
                key={fact}
                className="text-[14px] md:text-[15px] font-medium text-base-700"
              >
                {fact}
              </p>
            ))}
          </div>

          <p className="mt-[40px] text-center text-[16px] md:text-[17px] text-base-600">
            {t.references.closing}{" "}
            <a
              href="#kontakt"
              className="text-[#0195bd] font-semibold cursor-pointer hover:underline whitespace-nowrap"
              onClick={(event) => {
                event.preventDefault();
                scrollTo("kontakt");
              }}
            >
              {t.references.ctaLink}
            </a>
          </p>
        </div>
      </div>
    </>
  );
};
